import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function counterPriceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const priceType = control.get('price_type').value;
    const cashPrice = control.get('cash_price.amount').value;
    const basisPriceGroup = control.get('basis_price');

    const basisPoints = basisPriceGroup?.get('basisPoints')?.value;
    const month = basisPriceGroup?.get('month')?.value;
    const code = basisPriceGroup?.get('product_code')?.value;
    const year = basisPriceGroup?.get('year')?.value;
    // Check if price is provided
    const isPriceFilled = !!cashPrice;
    // Check if all fields in basisPrice group are filled
    const isBasisPriceFilled = basisPoints && month && code && year;

    // Return null if the form is valid (either price or basisPrice group must be filled)
    if (isPriceFilled || isBasisPriceFilled) {
      return null;
    }
    // Return validation error if neither is fully filled
    return { priceRequired: true };
  };
}
